/* eslint-disable */
let win = nw.Window.get() || '';

export default {
    big() {
        win.toggleFullscreen();
    },
    /**
     * 打开新窗口跳转
     * @param {*} url 
     * @param {*} option 
     * @param {*} callback 
     */
    openWin(url, option, callback) {
        let baseUrl = window.location
        nw.Window.open(`${baseUrl.origin}${baseUrl.pathname}#${url}`, { fullscreen: true, frame: true }, () => {
            // And listen to new window's focus event
            // callback(win)
            // win.on('focus', () => {
            // win.toggleFullscreen();
            // });
        });
    },
    close() {
        win.close();
    }
}